import type { File } from '@efdigital/ll-addon-data';
import { Heading } from '@efdigital/ll-addon-ui';
import FileUploader from '@efdigital/ll-admin-v2/components/files/file-uploader.gts';
import { LinkTo } from '@ember/routing';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class LibraryFoldersUpload extends Component {
  @service declare router: RouterService;

  onFileUploaded = (file: File) => {
    this.router.transitionTo('library.folders.file', file.id!);
  };

  <template>
    <div class="container py-5">
      <Heading @text="Private Files" @secondary="Upload File">
        <LinkTo @route="library.folders.index" class="btn btn-sm btn-primary">
          <iconify-icon inline icon="ph:arrow-left" />
          Back to Files
        </LinkTo>
      </Heading>

      <FileUploader
        @parentFolderId="|global"
        @onFileUploaded={{this.onFileUploaded}}
      />
    </div>
  </template>
}
